// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SIEzxOR2do7e92CZtzGA > div {
  display: flex;
  row-gap: 64px;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM {
  display: flex;
  flex-direction: column;
  max-width: 460px;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM ul {
  list-style-type: none;
  margin-top: 16px;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM li {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM li svg {
  width: 24px;
  height: 24px;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM li svg {
  stroke: #0eaf00;
  fill: #0eaf00;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .QDfBLsVHkXFD_KLs2jch {
  padding: 0 !important;
  margin-top: 40px;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .bntud0iEmrEYFAwORght {
  padding: 32px !important;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .ymGTVN9eyOWkIwSGthOm {
  flex-direction: column;
  align-items: stretch;
  margin: 16px 0;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .Vl2_8XHtgY9psc27bAYR {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .Aa0iHSj14aqd6sbXXC2D {
  flex: 1;
  padding: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
  color: #000;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .Aa0iHSj14aqd6sbXXC2D:hover {
  border-color: #0eaf00;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .Aa0iHSj14aqd6sbXXC2D.zfqd2rMwk_Kv2_rlWXPC {
  border-color: #0eaf00;
  border-width: 3px;
  background: #f0fff0;
  box-shadow: 0 0 8px rgba(14, 175, 0, 0.3);
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .Aa0iHSj14aqd6sbXXC2D .Vg4p3UdmgC5PwkN47G0f {
  font-size: 1.25rem;
  font-weight: bold;
  color: #0eaf00;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .Aa0iHSj14aqd6sbXXC2D .PIxI6LXaVrxYfrNvvnTW {
  position: absolute;
  top: -20px;
  right: 10px;
  background: #0eaf00;
  color: white;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  z-index: 1;
  opacity: 0.75;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .Aa0iHSj14aqd6sbXXC2D.zfqd2rMwk_Kv2_rlWXPC .PIxI6LXaVrxYfrNvvnTW {
  opacity: 1;
}
.SIEzxOR2do7e92CZtzGA .EFtPCYd7d7qp3t6wXtmM .Aa0iHSj14aqd6sbXXC2D .qoyK1ho3RT_0N2yeY83J {
  font-size: 0.8rem;
  color: #0eaf00;
  font-weight: 500;
  text-align: center;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
}
.SIEzxOR2do7e92CZtzGA .ITgCYSgBIgwxvgeMb9wQ {
  display: flex;
  margin: auto;
}
.SIEzxOR2do7e92CZtzGA .ITgCYSgBIgwxvgeMb9wQ .O4PjIbm3H2uoDKNdc_1n {
  animation: HKMGtPEvXSag6yX_LYdd 2s linear infinite;
}
@keyframes HKMGtPEvXSag6yX_LYdd {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.SIEzxOR2do7e92CZtzGA .rOoUIcG2tW1WRkCCu3nk {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 380px;
  height: 350px;
}
.SIEzxOR2do7e92CZtzGA .rOoUIcG2tW1WRkCCu3nk > svg {
  position: absolute;
  width: 100%;
  height: 100%;
}
.SIEzxOR2do7e92CZtzGA .rOoUIcG2tW1WRkCCu3nk > svg * {
  stroke: #0eaf00;
  fill: #0eaf00;
}
.SIEzxOR2do7e92CZtzGA .rOoUIcG2tW1WRkCCu3nk .HaXGRmtwM92b4RaHFrkm {
  position: absolute;
}
.SIEzxOR2do7e92CZtzGA .rOoUIcG2tW1WRkCCu3nk .HNioeefzM7mHhKkFFsK5 {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  opacity: 0.3;
}
.SIEzxOR2do7e92CZtzGA .rOoUIcG2tW1WRkCCu3nk .QNRSzUwOkqPGxwNbRUEL {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
}
.SIEzxOR2do7e92CZtzGA .rOoUIcG2tW1WRkCCu3nk .QNRSzUwOkqPGxwNbRUEL > p {
  font-size: 24px !important;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/modals/PaymentModal/PaymentModal.module.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,aAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAFJ;AAII;EACE,qBAAA;EACA,gBAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAHN;AAKM;EACE,WAAA;EACA,YAAA;AAHR;AAKQ;EACE,eAAA;EACA,aAAA;AAHV;AAQI;EACE,qBAAA;EACA,gBAAA;AANN;AASI;EACE,wBAAA;AAPN;AAUI;EACE,sBAAA;EACA,oBAAA;EACA,cAAA;AARN;AAWI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AATN;AAYI;EACE,OAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AAVN;AAYM;EACE,qBAAA;AAVR;AAaM;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;AAXR;AAcM;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;AAZR;AAeM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;AAbR;AAgBM;EACE,UAAA;AAdR;AAiBM;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAfR;AAoBE;EACE,aAAA;EACA,YAAA;AAlBJ;AAoBI;EACE,kDAAA;AAlBN;AAqBI;EACE;IACE,uBAAA;EAnBN;EAsBI;IACE,yBAAA;EApBN;AACF;AAwBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAtBJ;AAwBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAtBN;AAwBM;EACE,eAAA;EACA,aAAA;AAtBR;AA0BI;EACE,kBAAA;AAxBN;AA2BI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAzBN;AA4BI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AA1BN;AA4BM;EACE,0BAAA;EACA,gBAAA;AA1BR","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `SIEzxOR2do7e92CZtzGA`,
	"paymentDetails": `EFtPCYd7d7qp3t6wXtmM`,
	"learnMoreBtn": `QDfBLsVHkXFD_KLs2jch`,
	"paymentButton": `bntud0iEmrEYFAwORght`,
	"pricing": `ymGTVN9eyOWkIwSGthOm`,
	"planSelector": `Vl2_8XHtgY9psc27bAYR`,
	"planButton": `Aa0iHSj14aqd6sbXXC2D`,
	"selected": `zfqd2rMwk_Kv2_rlWXPC`,
	"price": `Vg4p3UdmgC5PwkN47G0f`,
	"savings": `PIxI6LXaVrxYfrNvvnTW`,
	"bonus": `qoyK1ho3RT_0N2yeY83J`,
	"loadingSpinner": `ITgCYSgBIgwxvgeMb9wQ`,
	"spinner": `O4PjIbm3H2uoDKNdc_1n`,
	"spin": `HKMGtPEvXSag6yX_LYdd`,
	"rightCol": `rOoUIcG2tW1WRkCCu3nk`,
	"checkoutWithBtn": `HaXGRmtwM92b4RaHFrkm`,
	"paymentPlaceholder": `HNioeefzM7mHhKkFFsK5`,
	"unAuth": `QNRSzUwOkqPGxwNbRUEL`
};
export default ___CSS_LOADER_EXPORT___;
